export default "__VITE_ASSET__2_LqqwWT__"